// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"27901e46","444":"1e2db8df","960":"a9b05190"}[chunkId] + ".chunk.js";
};